import * as Yup from "yup";

import { TextManager } from "Components/TextContext";
import { BRAND_MODEL_MAX_CHARACTER_LENGTH } from "../../vehicleConstants";
import { CaravanProductIntroFormValues } from "./interfaces";

export const validationSchema =
  (): Yup.ObjectSchema<CaravanProductIntroFormValues> => {
    const { getText } = TextManager;
    const caravanMaxLenght = {
      caravan_maxLength: BRAND_MODEL_MAX_CHARACTER_LENGTH,
    };

    return Yup.object().shape({
      brand: Yup.string()
        .required(getText("caravanform.validation.brand"))
        .max(
          BRAND_MODEL_MAX_CHARACTER_LENGTH,
          getText("caravanform.validation.brand_maxlength", {
            variables: caravanMaxLenght,
          }),
        ),
      model: Yup.string()
        .required(getText("caravanform.validation.model"))
        .max(
          BRAND_MODEL_MAX_CHARACTER_LENGTH,
          getText("caravanform.validation.model_maxlength", {
            variables: caravanMaxLenght,
          }),
        ),
      registrationYear: Yup.string().required(
        getText("caravanform.validation.registrationyear"),
      ),
    });
  };
